module.exports = __webpack_public_path__ + "img/3d9bc8a.jpg";